/* global localData, grecaptcha, google, axios */
const steps = document.querySelectorAll('div.steps-process');
const breadcrumbsItems = document.querySelectorAll('.purchase-process__indicator .purchase-process__indicator-text');
const loading = document.querySelector('.site-loader');
const orderPerks = ['input[name="delivery"]'];
const checkoutNeedsShipping = () => localData.requiresShipping !== '0';
const itemsToSaveInCookie = document.querySelectorAll(
  '#address_address, #address_name, #address_surname, #address_email, #address_post_number,' +
    ' #address_city, #address_country, #address_phone',
);
let stripe;
let stripeElement;
let elements;
if (document.querySelector('.sc-purchase-process-info-02') && localData.stripeKey && typeof localData === 'object') {
  stripe = Stripe(localData.stripeKey, {
    locale: localData.lang,
  });
}

const continueAsGuest = document.querySelector('.account-access-buttons--guest');
if (continueAsGuest) {
  continueAsGuest.addEventListener('click', () => {
    const activeStep = Number(getActiveStep());
    const nextStep = `sc-purchase-process-info-0${activeStep + 1}`;
    hideAllSteps();
    showStep(nextStep);
    continueAsGuest.closest('.purchase-process')?.classList.add('is-guest-continued');
  });
}

const getGooglePlacesCountryFieldName = (suffix) => {
  if (suffix === 'diff') {
    return 'diff_country';
  }
  if (suffix === 'company') {
    return 'company_country';
  }
  return 'address_country';
};

const getGooglePlacesAddressFieldName = (suffix) => (suffix === 'address' ? 'address_address' : `${suffix}_address`);

const resetCountryDropdownForPlaces = (suffix) => {
  const countryFieldName = getGooglePlacesCountryFieldName(suffix);
  const countryInputs = document.querySelectorAll(`[name="${countryFieldName}"]`);
  if (!countryInputs.length) {
    return;
  }

  countryInputs.forEach((radio) => {
    radio.checked = false;
  });

  const dropdownParent = countryInputs[0].closest('.dropdown');
  const dropdownPlaceholderText = dropdownParent?.querySelector('.dropdown__placeholder-text');
  if (dropdownPlaceholderText) {
    dropdownPlaceholderText.innerHTML = dropdownPlaceholderText.dataset.placeholder || '';
    dropdownPlaceholderText.removeAttribute('data-ehrm');
  }
  dropdownParent?.classList.remove('is-selected');
  dropdownParent?.dispatchEvent(new Event('change', { bubbles: true }));
};

const triggerCheckoutFieldValidation = (fieldName) => {
  const fieldElement = document.querySelector(`[data-fv-name="${fieldName}"]`);
  const form = fieldElement?.closest('form');
  const fv = form?.checkoutFormValidation;
  if (fv) {
    fv.revalidateField(fieldName);
  }
};

const fillInputsGooglePlaces = (addressComponents, suffix = '', { missingStreetNumber = false } = {}) => {
  const { route, country, street_number, postal_code, postal_town, locality } = addressComponents;
  const addressFieldName = getGooglePlacesAddressFieldName(suffix);
  const addressInput = document.querySelector(`[name="${addressFieldName}"]`);
  const postNumberInput = document.querySelector(`[name="${suffix}_post_number"]`);
  const cityInput = document.querySelector(`[name="${suffix}_city"]`);

  if (addressInput) {
    addressInput.value = missingStreetNumber ? (route || '').trim() : `${route} ${street_number}`.trim();
    if (missingStreetNumber) {
      addressInput.setAttribute('data-places-missing-street-number', 'true');
    } else {
      addressInput.removeAttribute('data-places-missing-street-number');
    }
  }
  if (postNumberInput) {
    postNumberInput.value = postal_code;
  }
  if (cityInput) {
    cityInput.value = postal_town || locality;
  }

  const countryFieldName = getGooglePlacesCountryFieldName(suffix);
  resetCountryDropdownForPlaces(suffix);
  const countryInput = country && document.querySelector(`[name="${countryFieldName}"][value="${country}"]`);
  if (countryInput) {
    countryInput.checked = true;
    const dropdownParent = countryInput.closest('.dropdown');
    const dropdownPlaceholderText = dropdownParent?.querySelector('.dropdown__placeholder-text');
    const optionLabel = countryInput.closest('.dropdown__list-item')?.querySelector('.dropdown__list-option');
    if (dropdownPlaceholderText && optionLabel) {
      dropdownPlaceholderText.innerHTML = optionLabel.innerHTML;
      dropdownPlaceholderText.dataset.ehrm = optionLabel.dataset.ehrm || countryInput.value;
      dropdownParent.classList.add('is-selected');
    }
    countryInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  triggerCheckoutFieldValidation(addressFieldName);
  triggerCheckoutFieldValidation(countryFieldName);
};
const initGooglePlacesSearch = () => {
  if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
    return;
  }

  const countryMap = {
    sl: 'si',
    hr: 'hr',
  };
  const country = countryMap[localData.lang];
  const options = country
    ? {
        componentRestrictions: {
          country,
        },
      }
    : {};
  ['#company_address', '#address_address', '#diff_address'].forEach((inputId) => {
    const input = document.querySelector(inputId);
    if (!input) return;

    const autocomplete = new google.maps.places.Autocomplete(input, options);

    input.addEventListener('input', () => {
      input.removeAttribute('data-places-missing-street-number');
      const fieldName = input.getAttribute('data-fv-name') || input.name;
      if (fieldName) {
        triggerCheckoutFieldValidation(fieldName);
      }
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();

      const addressComponents = {
        postal_code: '',
        street_number: '',
        country: '',
        route: '',
        postal_town: '',
        locality: '',
      };

      place.address_components?.forEach((component) => {
        const type = component.types[0];

        if (addressComponents[type] !== undefined) {
          addressComponents[type] = type === 'country' ? component.short_name : component.long_name;
        }
      });

      const missingStreetNumber = !addressComponents.street_number;
      if (missingStreetNumber) {
        const inputValueParts = input.value.split(',');
        addressComponents.route = (inputValueParts[0] || input.value).trim();
      }

      let suffix = 'address';
      if (input.id === 'company_address') {
        suffix = 'company';
      } else if (input.id === 'diff_address') {
        suffix = 'diff';
      }
      fillInputsGooglePlaces(addressComponents, suffix, { missingStreetNumber });
    });
  });
};
const hideSidebar = () => {
  const processSidebar = document.querySelector('.purchase-process-sidebar');
  if (processSidebar && window.innerWidth < 1023) {
    const content = processSidebar.querySelector('.purchase-process-sidebar__content');
    slideUp(content, 300);
    processSidebar.classList.remove('is-open');
  }
};
const hideAllSteps = () => {
  steps.forEach((item) => {
    item.hidden = true;
  });
};
const showStep = (step) => {
  const number = Number(step.split('-').pop());
  // show active step
  steps.forEach((item) => {
    item.hidden = !item.classList.contains(step);
  });
  breadcrumbsItems.forEach((item) => {
    const icon = item.closest('.purchase-process__indicator-icon');
    if (!icon || !item.dataset.action) {
      return;
    }
    const itemNumber = Number(item.dataset.action.split('-').pop());
    icon.classList.toggle('is-done', itemNumber <= number - 1);
    icon.classList.toggle('is-active', itemNumber <= number);
  });
};
const getActiveStep = () => {
  let active = 0;
  steps.forEach((item) => {
    if (item.hidden === false) {
      const [result] = item.id.match(/\d+/);
      active = result;
    }
  });
  return active;
};

const getInputData = () => {
  const formData = {};
  // eslint-disable-next-line consistent-return
  const getInputDataIn = (input) => {
    if (input.type !== 'checkbox' && input.type !== 'radio') {
      return input.value.trim();
    }
    if (input.checked) {
      if (['address_country', 'company_country', 'diff_country'].includes(input.name)) {
        return input.value.trim();
      }
      return input.dataset.title || input.dataset.text || input.id.trim() || input.value.trim();
    }
  };
  document.querySelectorAll('input, textarea, select').forEach((input) => {
    const getValue = getInputDataIn(input);
    if (
      getValue !== undefined &&
      getValue !== '' &&
      getValue !== 'on' &&
      input.name &&
      input.name !== 'g-recaptcha-response'
    ) {
      formData[input.name] = getValue;
    }
  });
  return formData;
};

const initializeStripe = () => {
  document.querySelector('#payment-element').innerHTML = '';
  const axiosData = new FormData();
  axiosData.append('action', 'createStripeClientKey');
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axios
    .post(localData.apiURL, axiosData)
    .then((response) => {
      localData.clientSecret = response.data.clientSecret;
      elements = stripe.elements({ clientSecret: response.data.clientSecret });
      const paymentElement = elements.create('payment');
      paymentElement.mount('#payment-element');
    })
    .catch((error) => {
      showMessage(error.response.data.data.error);
    });
};

const showMessage = (messageText) => {
  const messageContainer = document.querySelector('#payment-message');
  messageContainer.hidden = false;
  messageContainer.innerHTML = messageText;
};

const getSelectedPaymentMethod = () => {
  const selectedMethod = Array.from(document.querySelectorAll('input[name="payment-methods"]')).find(
    (item) => item.checked,
  );
  return selectedMethod ? selectedMethod.id : '';
};

const handleSubmitStripe = async (token) => {
  const { error, paymentIntent } = await stripe.confirmPayment({
    elements,
    redirect: 'if_required',
    confirmParams: {
      return_url: `${localData.apiURL}?action=updateOrderStatus`,
    },
  });
  setTimeout(() => {
    toggleLoaderClass(loading, false);
  }, 2000);

  if (error) {
    if (error.type === 'card_error' || error.type === 'validation_error') {
      showMessage(localData.translations.payment_error);
    } else {
      showMessage('An unexpected error occurred.');
    }
    return;
  }

  // Stripe payment intents use manual capture, so a successful authorization
  // is reported as `requires_capture` rather than `succeeded`.
  if (!paymentIntent || !['requires_capture', 'succeeded'].includes(paymentIntent.status)) {
    showMessage(localData.translations.payment_error);
    toggleLoaderClass(loading, false);
    return;
  }

  const axiosData = new FormData();
  axiosData.append('action', 'createOrderFromCartItems');
  axiosData.append('type', 'stripe');
  axiosData.append('token', token);
  axiosData.append('stripePaymentIntentId', paymentIntent.id);
  axiosData.append('stripePaymentIntentSecret', paymentIntent.client_secret);
  axiosData.append('inputs', JSON.stringify(getInputData()));
  const response = await axios.post(localData.apiURL, axiosData);

  window.location.href = response.data?.data?.url;
};
const handleSubmitMoney = (token, type) => {
  const axiosData = new FormData();
  axiosData.append('action', 'createOrderFromCartItems');
  axiosData.append('type', type === 'cash-money' ? 'money' : type);
  axiosData.append('token', token);
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axios.post(localData.apiURL, axiosData).then((response) => {
    window.location.href = response.data.data.url;
    setTimeout(() => {
      toggleLoaderClass(loading, false);
    }, 2000);
  });
};

const handleSubmitPaypal = (status) => {
  toggleLoaderClass(loading, true);
  grecaptcha.ready(() => {
    grecaptcha.execute(localData.captchaSiteKey, { action: 'createOrderFromCartItems' }).then((token) => {
      const axiosData = new FormData();
      axiosData.append('action', 'createOrderFromCartItems');
      axiosData.append('type', 'paypal');
      axiosData.append('token', token);
      axiosData.append('inputs', JSON.stringify(getInputData()));
      axiosData.append('paypal-status', JSON.stringify(status));
      axiosData.append('paypal_pre_order_id', localData.paypal_pre_order_id || 0);
      axiosData.append('order_key', localData.order_key || 0);
      axios.post(localData.apiURL, axiosData).then((response) => {
        if (response.status === 200) {
          window.location.href = response.data.data.url;
        }
        setTimeout(() => {
          toggleLoaderClass(loading, false);
        }, 3000);
      });
    });
  });
};

const initializePayPal = () => {
  document.querySelector('.btn-paypal').innerHTML = '';
  const axiosData = new FormData();
  axiosData.append('action', 'createPayPalAmount');
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axios.post(localData.apiURL, axiosData).then((response) => {
    if (response.status === 200) {
      window.paypal
        .Buttons({
          createOrder(data, actions) {
            return actions.order.create({
              application_context: {
                shipping_preference: 'NO_SHIPPING',
              },
              purchase_units: [
                {
                  custom_id: localData.order_key,
                  amount: {
                    value: response.data.amount,
                  },
                },
              ],
            });
          },
          onClick(data, actions) {
            const formData = new FormData();
            formData.append('action', 'createOrderFromCartItems');
            formData.append('inputs', JSON.stringify(getInputData()));
            formData.append('token', JSON.stringify(data));
            formData.append('type', 'paypal');
            formData.append('pre_order', 'true');
            return fetch(localData.apiURL, {
              method: 'POST',
              body: formData,
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.data.order_id) {
                  localData.paypal_pre_order_id = data.data.order_id;
                  localData.order_key = data.data.order_key;
                  return actions.resolve();
                }
                return actions.reject();
              });
          },
          onApprove(data, actions) {
            const registration = new FormData();
            registration.append('action', 'registerPaypalVoucherPayment');
            registration.append('order_id', localData.paypal_pre_order_id);
            registration.append('order_key', localData.order_key);
            registration.append('paypal_order_id', data.orderID);
            return axios
              .post(localData.apiURL, registration)
              .then(() => actions.order.capture())
              .then((status) => {
                handleSubmitPaypal(status);
              });
          },
          onError: (err) => {
            showMessage(err);
          },
        })
        .render('.btn-paypal');
    }
  });
};

const reInitExpress = () => {
  const axiosData = new FormData();
  axiosData.append('action', 'createPayPalAmount');
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axiosData.append('without_shipping', true);
  axios.post(localData.apiURL, axiosData).then((response) => {
    stripeElement.update({
      amount: Number(response.data.amount),
    });
  });
};

const reInitPayMethods = () => {
  const deliveryInput = document.querySelector('input[name="delivery"]');
  const paymentContainer = document
    .querySelector('input[name="payment-methods"]')
    .closest('.purchase-process-dropdowns__item');

  const paymentDrop = paymentContainer.querySelector('.purchase-process-dropdown__drop');
  const deliveryContainer = deliveryInput?.closest('.purchase-process-dropdowns__item');
  const deliveryMessage = deliveryContainer?.querySelector('.fv-plugins-message-container');

  const selectedDelivery = document.querySelector('input[name="delivery"]:checked');

  if (checkoutNeedsShipping() && !selectedDelivery) {
    const selectedPayment = document.querySelector('input[name="payment-methods"]:checked');

    if (selectedPayment) {
      selectedPayment.checked = false;
    }

    if (deliveryMessage) {
      deliveryMessage.textContent = localData.translations.delivery_warning;
    }
    paymentDrop.hidden = true;
    return;
  }

  paymentDrop.hidden = false;

  const selectedPayment = document.querySelector('input[name="payment-methods"]:checked');

  // eslint-disable-next-line default-case
  switch (selectedPayment?.id) {
    case 'credit_cards':
      initializeStripe();
      break;
    case 'paypal':
      initializePayPal();
      break;
  }

  reInitExpress();
  if (deliveryMessage) {
    deliveryMessage.textContent = '';
  }
};

const eventHandleCheckoutForm = (form) => {
  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {
      ...getAddressFieldValidators(form),
      ...(checkoutNeedsShipping()
        ? {
            delivery: {
              validators: {
                notEmpty: {
                  message: localData.translations.delivery_warning,
                },
              },
            },
          }
        : {}),
      'payment-methods': {
        validators: {
          notEmpty: {
            message: localData.translations.payment_warning,
          },
        },
      },
      checkout_terms: {
        validators: {
          notEmpty: {
            message: localData.translations.privacy_warning,
          },
        },
      },
    },
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => {
          const parentElement = element.closest(
            '.mod-input, .dropdown, .purchase-process-dropdowns__item-dropdowns, .checkbox[data-component="at-checkbox"], .delivery-banner__cards',
          );
          return parentElement || element;
        },
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'input change',
      }),
      excluded: new FormValidation.plugins.Excluded({
        excluded: (field, element) => {
          const control = ['address_country', 'company_country', 'diff_country'].includes(field)
            ? element.closest('.dropdown') || element
            : element;
          return element.disabled || FormValidation.plugins.Excluded.defaultIgnore(field, control);
        },
      }),
      submitButton: new FormValidation.plugins.SubmitButton({
        buttons(form) {
          const stepForm = form.closest('.steps-process');

          return [
            ...stepForm.querySelectorAll('button[type="submit"]'),
            ...document.querySelectorAll('.purchase-process__indicator-text[data-action]'),
          ];
        },
      }),
    },
  }).on('core.element.validated', (e) => {
    // e.element presents the field element
    // e.valid indicates the field is valid or not
    if (e.element.hasAttribute('required')) {
      // Get the field value
      const value = fv.getElementValue(e.field, e.element);
      const container = FormValidation.utils.closest(
        e.element,
        '.mod-input,.purchase-process-dropdowns__item-dropdowns,.checkbox[data-component="at-checkbox"],.dropdown[data-component="at-dropdown"],.delivery-banner__cards',
      );
      FormValidation.utils.classSet(container, {
        'is-validation-failed': value.trim() === '' || !e.valid,
      });
    }
  });

  form.checkoutFormValidation = fv;
};

const saveContactInfoToCookie = () => {
  if (document.querySelector('#save_address') && document.querySelector('#save_address').checked) {
    const inputValues = {};
    itemsToSaveInCookie.forEach((input) => {
      if (input && (input.type === 'text' || input.type === 'email')) {
        inputValues[input.id] = input.value;
      }
    });
    Cookies.set('users_data', JSON.stringify(inputValues), true, { expires: 365 });
  } else {
    document.cookie = 'users_data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
};

const fillUserDataFromCookie = () => {
  const cookie = Cookies.get('users_data');
  if (cookie) {
    const jsonData = JSON.parse(cookie);
    itemsToSaveInCookie.forEach((input) => {
      if (input && (input.type === 'text' || input.type === 'email') && input.closest('.mod-input')) {
        if (!input.value && jsonData[input.id]) {
          input.closest('.mod-input').classList.add('is-focused');
          input.value = jsonData[input.id];
        }
      }
    });
    const saveCheckbox = document.querySelector('#save_address');
    if (saveCheckbox) {
      saveCheckbox.checked = true;
    }
  }
};

const initPaymentsBoxes = () => {
  document.querySelectorAll('#credit_cards, #paypal').forEach((item) => {
    item.addEventListener('click', () => {
      reInitPayMethods();
    });
  });
};

const initExpressCheckout = () => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'justReturnAmount');
  formDataInput.append('inputs', JSON.stringify(getInputData()));
  axios
    .post(localData.apiURL, formDataInput)
    .then((response) => {
      stripeElement = stripe.elements({
        mode: 'payment',
        amount: response.data.data.amount,
        currency: 'eur',
      });
      const expressCheckoutElement = stripeElement.create('expressCheckout', {
        buttonType: {
          googlePay: 'checkout',
          applePay: 'check-out',
          paypal: 'paypal',
        },
        layout: {
          maxRows: 3,
        },
      });
      expressCheckoutElement.mount('.purchase-process-form__fast-payment__items');
      expressCheckoutElement.on('shippingaddresschange', (event) => {
        const filteredData = localData.shipping.slice(0, 9);
        event.resolve({
          shippingRates: filteredData,
        });
      });
      expressCheckoutElement.on('click', (event) => {
        event.resolve({
          emailRequired: true,
          ...(checkoutNeedsShipping()
            ? { shippingAddressRequired: true, shippingRates: localData.shipping }
            : { shippingAddressRequired: false, billingAddressRequired: true }),
          phoneNumberRequired: true,
        });
      });
      expressCheckoutElement.on('confirm', async (event) => {
        toggleLoaderClass(loading, true);
        const { error: submitError } = await stripeElement.submit();
        const handleError = (error) => {
          const messageContainer = document.querySelector('#error-message');
          messageContainer.hidden = false;
          messageContainer.textContent = error.message;
          setTimeout(() => {
            messageContainer.hidden = true;
          }, 15000);
          toggleLoaderClass(loading, false);
        };
        if (submitError) {
          handleError(submitError);
          return;
        }
        const formDataInputRes = new FormData();
        formDataInputRes.append('action', 'createPayPalAmount');
        formDataInputRes.append('create_stripe_secret', true);
        formDataInputRes.append('express_checkout_data', JSON.stringify(event));
        formDataInputRes.append('inputs', JSON.stringify(getInputData()));
        try {
          const res = await axios.post(localData.apiURL, formDataInputRes);
          const { client_secret: clientSecret, url } = res.data.data;
          const { error } = await stripe.confirmPayment({
            elements: stripeElement,
            clientSecret,
            confirmParams: {
              return_url: url,
            },
          });
          if (error) {
            handleError(error);
          }
        } catch (postError) {
          handleError(postError);
        }
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

const resetPaymentsOnPerksClick = () => {
  orderPerks.forEach((checkers) => {
    const checkboxes = document.querySelectorAll(checkers);
    checkboxes.forEach((item) => {
      item.addEventListener('click', () => {
        setTimeout(() => {
          reInitPayMethods();
        }, 200);
      });
    });
  });
};

const sendGtagEvent = () => {
  if (localData.analyticsCart?.items?.length) {
    pushEcommerceEvent('begin_checkout', localData.analyticsCart);
  }
};

let lastShippingInfo = '';
const sendShippingInfoEvent = (input) => {
  const isStorePickup = !!input.closest('.store-pickup-item');
  // Store pickup counts only once a store is chosen (store ID is written to the input value)
  if (isStorePickup && !/^\d+$/.test(input.value)) {
    return;
  }
  const selection = isStorePickup ? input.value : input.id;
  if (!localData.analyticsCart?.items?.length || selection === lastShippingInfo) {
    return;
  }
  lastShippingInfo = selection;
  pushEcommerceEvent('add_shipping_info', {
    ...localData.analyticsCart,
    shipping_tier: isStorePickup ? 'store_pickup' : input.id.split(':')[0],
  });
};

// Same labels as OrderHelpers::getAnalyticsPaymentType() for the purchase event
const analyticsPaymentTypes = {
  credit_cards: 'Credit Card',
  paypal: 'PayPal',
  invoice: 'Invoice',
  'cash-money': 'Cash on delivery',
};
let lastPaymentInfo = '';
const sendPaymentInfoEvent = (input) => {
  if (!localData.analyticsCart?.items?.length || input.id === lastPaymentInfo) {
    return;
  }
  lastPaymentInfo = input.id;
  pushEcommerceEvent('add_payment_info', {
    ...localData.analyticsCart,
    payment_type: analyticsPaymentTypes[input.id] || input.id,
  });
};

const refreshPageOnBackEvent = () => {
  window.addEventListener('pageshow', (event) => {
    const navigationEntries = performance.getEntriesByType('navigation');
    if (
      event.persisted ||
      (window.performance && navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward')
    ) {
      window.location.reload();
    }
  });
};

const setStepValidationForms = () => {
  ['sc-purchase-process-info-01', 'sc-purchase-process-info-02'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      eventHandleCheckoutForm(form.querySelector('form'));
    }
  });
};

const validateCheckoutForm = async (form) => {
  const fv = form?.checkoutFormValidation;
  if (!fv) return false;
  Object.keys(fv.getFields()).forEach((field) => {
    if (fv.getElements(field).length) fv.resetField(field, false);
  });
  return (await fv.validate()) === 'Valid';
};

const setButtonFormEvents = () => {
  document.querySelectorAll('a[data-action], button[data-action]').forEach((el) => {
    el.addEventListener('click', async (e) => {
      e.preventDefault();
      const stepWantToGo = Number(el.dataset.action.match(/\d+/)[0]);
      const activeStep = Number(getActiveStep());
      let goToStep = el.dataset.action;
      const form = document.querySelector(`.sc-purchase-process-info-0${activeStep} form`);
      if (stepWantToGo > activeStep && !(await validateCheckoutForm(form))) {
        form?.querySelector('.is-validation-failed')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!form?.querySelector('.is-validation-failed') || stepWantToGo <= activeStep) {
        if (
          stepWantToGo === 3 &&
          activeStep === 1 &&
          (!checkoutNeedsShipping() || !document.querySelector('#delivery-type')?.checked)
        ) {
          // prevent to skip second step from first one
          goToStep = 'sc-purchase-process-info-02';
        }
        if (goToStep === 'sc-purchase-process-info-02') {
          if (document.querySelector('#save_address')) {
            saveContactInfoToCookie();
          }
        }
        hideSidebar();
        hideAllSteps();
        showStep(goToStep);
        document.querySelector('main').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (document.querySelector('.is-validation-failed')) {
        document.querySelector('.is-validation-failed').scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  const proceedToPayment = (token, paymentMethod) => {
    if (paymentMethod === 'credit_cards') {
      handleSubmitStripe(token);
    } else if (paymentMethod === 'invoice' || paymentMethod === 'cash-money') {
      handleSubmitMoney(token, paymentMethod);
    }
  };

  document.querySelectorAll('.sc-purchase-process-info-02 button[type="submit"]').forEach((item) => {
    item.addEventListener('click', async (ev) => {
      ev.preventDefault();
      const form = item.closest('form');
      if (!(await validateCheckoutForm(form))) return;
      if (!form.querySelector('.is-validation-failed')) {
        const paymentMethod = getSelectedPaymentMethod();
        grecaptcha.ready(() => {
          if (!document.querySelector('.site-loader.is-loading')) {
            toggleLoaderClass(loading, true);
            document.querySelector('#payment-message').hidden = true;

            const stockData = new FormData();
            stockData.append('action', 'finalStockCheck');
            stockData.append('inputs', JSON.stringify(getInputData()));

            axios
              .post(localData.apiURL, stockData)
              .then((stockResponse) => {
                if (stockResponse.data.data.items_in_stock) {
                  grecaptcha.execute(localData.captchaSiteKey, { action: 'createOrderFromCartItems' }).then((token) => {
                    proceedToPayment(token, paymentMethod);
                  });
                } else {
                  toggleLoaderClass(loading, false);
                  document.body.classList.add('out-of-stock-modal-open');
                  let confirmed = false;
                  const onConfirm = () => {
                    if (confirmed) return;
                    confirmed = true;
                    document.body.classList.remove('out-of-stock-modal-open');
                    // Missing product was already removed server-side; refresh the
                    // cart and stay on the payment step so the buyer can re-review.
                    sessionStorage.setItem('checkout_step', 'sc-purchase-process-info-02');
                    window.location.reload();
                  };
                  document
                    .querySelectorAll('.confirm-out-of-stock-modal')
                    .forEach((confirmBtn) => confirmBtn.addEventListener('click', onConfirm));
                }
              })
              .catch((error) => {
                toggleLoaderClass(loading, false);
                showMessage(localData.translations.payment_error);
                console.error(error);
              });
          }
        });
      }
    });
  });
};

const promoCodeSuccess = (pricesHtml, shippingIndicatorHtml, deliveryPrices, response) => {
  const shippingIndicatorEl = document.querySelector('.free-shipping-indicator');
  const cartSummaryEl = document.querySelector('.cart-module__sidebar-cart-summary');
  const ppCartSummaryEl = document.querySelector('.purchase-process-prices');
  const ppDeliveryFormEl = document.querySelector('#sc-purchase-process-info-02');
  if (shippingIndicatorEl) {
    shippingIndicatorEl.outerHTML = shippingIndicatorHtml;
  }
  if (cartSummaryEl) {
    cartSummaryEl.innerHTML = pricesHtml;
  }
  if (ppCartSummaryEl) {
    ppCartSummaryEl.innerHTML = pricesHtml;
  }
  updateLoyaltyCard(response.data.data.loyalty_card_html);
  if (ppDeliveryFormEl) {
    deliveryPrices.forEach((deliveryPrice) => {
      const price = ppDeliveryFormEl
        .querySelector(`[id="${deliveryPrice.delivery_type}"]`)
        ?.closest('.purchase-process-dropdown__header')
        ?.querySelector('.checkbox__info-price');
      if (price) {
        price.textContent = deliveryPrice.delivery_price;
      }
    });
  }
  if (response.data.data.shipping) {
    localData.shipping = response.data.data.shipping;
    response.data.data.shipping.forEach((delivers) => {
      document.querySelectorAll('input[name="delivery"]').forEach((deliveryChecks) => {
        if (deliveryChecks.id === delivers.id) {
          deliveryChecks
            .closest('.purchase-process-dropdown__header')
            .querySelector('.checkbox__info-price').textContent = delivers.amountText;
        }
      });
    });
  }
};

const axiosCalculateTotals = async () => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'calculateTotals');
  formDataInput.append('lang', localData.lang);
  try {
    await axios.post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } catch (err) {
    console.error(err);
  }
};

attachEvent('.purchase-process-sidebar__prices-item button', 'click', async (ev) => {
  const button = ev.target.closest('button');
  const item = ev.target.closest('.purchase-process-sidebar__prices-item');
  const formDataInput = new FormData();
  formDataInput.append('action', 'removeCouponCode');
  formDataInput.append('promo_code', button.dataset.code);
  formDataInput.append('lang', localData.lang);
  try {
    const response = await axios.post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    item.remove();
    promoCodeSuccess(
      response.data.data.cart_prices_html,
      response.data.data.free_shipping_indicator_html,
      response.data.data.delivery_prices,
      response,
    );
    await axiosCalculateTotals();
    if (document.querySelector('.sc-purchase-process-info-02')) {
      reInitPayMethods();
    }
  } catch (err) {
    console.error(err);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.sc-purchase-process-info-01')) {
    return;
  }
  refreshPageOnBackEvent();
  setStepValidationForms();
  setButtonFormEvents();
  fillUserDataFromCookie();
  initPaymentsBoxes();
  initExpressCheckout();
  initGooglePlacesSearch();
  resetPaymentsOnPerksClick();
  sendGtagEvent();
  attachEvent('input[name="delivery"]', 'change', (ev) => {
    if (ev.target.checked) {
      sendShippingInfoEvent(ev.target);
    }
  });
  attachEvent('input[name="payment-methods"]', 'change', (ev) => {
    if (ev.target.checked) {
      sendPaymentInfoEvent(ev.target);
    }
  });

  const checkoutStep = sessionStorage.getItem('checkout_step');
  if (checkoutStep) {
    sessionStorage.removeItem('checkout_step');
    hideAllSteps();
    showStep(checkoutStep);
  }
});
